<script lang="ts">
	//UI
	import { SlotSelect } from "@hitit/new_ui";
	//Utils
	//Types
	export let state = "";
	export let selectOptions = ["OBSOLETE", "PUBLISHED", "DRAFT"].map((v) => ({
		label: v,
		value: v,
		display: v,
	}));
	//Props
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="state">
	<SlotSelect
		bind:value={state}
		-document-state-selector
		svg
		backgroundColor="#f0f0f4"
		items={selectOptions}
		let:displayValue>
		<div class="select-inner">
			<span
				class="icon"
				class:publish={displayValue === 'PUBLISHED'}
				class:obsolate={displayValue === 'OBSOLETE'} />
			<span class="value"> {displayValue} </span>
		</div>
	</SlotSelect>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.state {
		display: flex;
		gap: 10px;
		color: #46474b;
		font-weight: 200;
		width: 153px;
		height: 32px;
		:global(.-document-state-selector) {
			padding: 10px;
		}
		.select-inner {
			display: flex;
			gap: 10px;
			align-items: center;
			flex-grow: 1;

			.icon {
				width: 15px;
				height: 15px;
				border-radius: 15px;
				background-color: #bcbfc3;

				&.publish {
					background-color: #44e4ae;
				}

				&.obsolate {
					background-color: #ffce00;
				}
			}
		}
	}

	@include DesktopSize {
		.state {
			width: 183px;
			height: 40px;
			.select-inner {
				font-size: 1.25rem;
				.icon {
					width: 20px;
					height: 20px;
				}
			}
		}
	}

</style>
